<template>
  <div class="ewb-footer">
    <div class="ewb-container">
      <p class="ewb-footer-content">
        主办单位：榆林市工程建设项目审批制度改革领导小组
      </p>
      <p class="ewb-footer-content">
       技术中心电话：0912-xxxxxxx
      </p>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
  .el-footer{
    padding: 0 !important;
  }
  .ewb-footer {
    padding:0 0;
    margin: 0;
    z-index: -1;
    height: 100%;
    background-color: #898989;
  }
  .ewb-container {
    width: 100%;
    margin: 0 auto;
  }
  .ewb-footer-content {
    line-height: 22px;
    text-align: center;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/kjfx/main/Footer.vue